import React, { useCallback, useState, useEffect } from 'react';
import DefaultModal from '../../../components/Modal/DefaultModal';
import { Row, Form, Col } from 'reactstrap';
import ReactButton from 'components/Buttons/ReactButton';
import TemplateService from '../service';

const UpdateMedia = ({
  isModalOpen,
  onModalToggle,
  templateId,
  templateName,
  onMediaUpdate
}) => {
  const closeModal = useCallback(() => onModalToggle(false), [onModalToggle]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    const fetchTemplate = async () => {
      if (isModalOpen && templateId) {
        try {
          const response = await TemplateService.getTemplateById(templateId);
          const template = response.data;

          if (template?.media) {
            setPreview(template.media);
          } else {
            setPreview(null);
          }
        } catch (error) {
          console.error('Erro ao buscar template:', error);
          setPreview(null);
        }
      }
    };

    if (isModalOpen) {
      fetchTemplate();
    }
  }, [isModalOpen, templateId]);

  useEffect(() => {
    if (selectedFile) {
      const objectUrl = URL.createObjectURL(selectedFile);
      setPreview(objectUrl);

      return () => URL.revokeObjectURL(objectUrl);
    }
  }, [selectedFile]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };

  const handleSave = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append('id', templateId);

      if (selectedFile) {
        formData.append('file', selectedFile);
      }

      const response = await TemplateService.updateTemplateMedia(formData);

      if (onMediaUpdate && response.data?.media) {
        onMediaUpdate(templateId, response.data.media);
      }

      closeModal();
    } catch (error) {
      console.error('Erro ao salvar mídia:', error);
    }
  };

  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title={`Enviar Media - ${templateName || 'Sem Nome'}`}
      showCloseButton={false}
      modalContainerClasses="modal-sm"
    >
      <Form onSubmit={handleSave}>
        <Row className="mb-3">
          <Col sm="12">
            <input
              id="image_upload"
              type="file"
              onChange={handleFileChange}
              style={{
                display: 'none'
              }}
            />
            <label
              htmlFor="image_upload"
              style={{
                display: 'inline-block',
                padding: '10px 20px',
                fontSize: '14px',
                fontWeight: '600',
                color: '#fff',
                backgroundColor: '#28a745',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                textAlign: 'center',
                transition: 'all 0.3s ease'
              }}
            >
              Enviar Arquivo
            </label>
          </Col>
        </Row>
        {preview && (
          <Row className="mb-3">
            <Col sm="12">
              <img
                src={preview}
                alt="Pré-visualização"
                style={{
                  width: '100%',
                  maxHeight: '300px',
                  objectFit: 'contain'
                }}
              />
            </Col>
          </Row>
        )}
        <hr />
        <ReactButton btnColor="confirmation" type="submit">
          Salvar
        </ReactButton>
        <ReactButton btnColor="cancelation" type="button" onClick={closeModal}>
          Fechar
        </ReactButton>
      </Form>
    </DefaultModal>
  );
};

export default UpdateMedia;
